{
    "AdminControl_PolicyApplied": "Política aplicada",
    "AdminControl_RecordingPolicyDetails": "Detalhes da Política de Gravação",
    "AdminControl_DisplayName": "Nome de exibição:",
    "AdminControl_UserPrincipalName": "Nome principal do usuário",
    "AdminControl_TeamsComplianceRecordingPolicy": "Política de gravação de conformidade do Teams",
    "AdminControl_PresenceStatus": "Status de presença",
    "AdminControl_CopiedToClipboard": "Copiado para a área de transferência",
    "AdminControl_ResponseSuccess": "Tarefa concluída com sucesso",
    "NAME": "AdminControlLanguage"
}